import { render, staticRenderFns } from "./dutyList.vue?vue&type=template&id=4431e3b2"
import script from "./dutyList.vue?vue&type=script&lang=js"
export * from "./dutyList.vue?vue&type=script&lang=js"
import style0 from "./dutyList.vue?vue&type=style&index=0&id=4431e3b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports